import { ConfirmationService } from 'primeng/api';
import { TranslationService } from '../../../shared/translation/translation.service';
import { ObservationService } from '../../../shared/observation/observation.service';
import { UserService } from 'src/app/users/shared/user.service';
import { PagedResultGeneric } from '../../../shared/model/paged-result.model';
import { SalesOpportunitySearchDto } from '../../../sales-opportunities/shared/dto/sales-opportunity-search.dto';
import { Component, OnInit, OnChanges, Input, SimpleChanges, ViewChild } from '@angular/core';
import { SalesOpportunityDto } from '../../../sales-opportunities/shared/dto/sales-opportunity.dto';
import { SalesOpportunityService } from '../../../sales-opportunities/shared/sales-opportunity.service';
import { SalesOpportunityEditDialogComponent } from 'src/app/sales-opportunities/sales-opportunity-edit-dialog/sales-opportunity-edit-dialog.component';
import { SecurityAccessLevelEnum } from 'src/app/shared/auth/enum/security-access-level.enum';

@Component({
  selector: 'wl-profile-view-sales-opportunities',
  templateUrl: './profile-view-sales-opportunities.component.html',
  styleUrls: ['./profile-view-sales-opportunities.component.less'],
    standalone: false
})
export class ProfileViewSalesOpportunitiesComponent implements OnInit, OnChanges {
  @Input() profileId: number;
  @ViewChild(SalesOpportunityEditDialogComponent) editDialog: SalesOpportunityEditDialogComponent;

  public salesOpps: Array<SalesOpportunityDto>;
  public rejectText: string;
  public acceptText: string;
  profileModuleFullAccess: boolean = false;
  profileContactsTabFullAccess: boolean = false;

  constructor(
    private _salesOppService: SalesOpportunityService,
    private _translationService: TranslationService,
    private _observationService: ObservationService,
    private _confirmationService: ConfirmationService,
    private _userService: UserService
  ) {}

  ngOnInit() {
    this._userService.getCurrentUserSecurityElementAccessLevel('Profiles_Module').then((userAccessLevel: number) => {
      this.profileModuleFullAccess = userAccessLevel > SecurityAccessLevelEnum.ReadOnlyAccess;

      if (this.profileModuleFullAccess) {
        this._userService.getCurrentUserSecurityElementAccessLevel('ProfileContacts_Tab').then((userAccessLevel: number) => {
          this.profileContactsTabFullAccess = userAccessLevel > SecurityAccessLevelEnum.ReadOnlyAccess;
        });
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.profileId) {
      this.loadOpps(1, true, true);
    }

    this._observationService.observeProfiles().subscribe((id) => {
      if (id === this.profileId) {
        this.loadOpps(1, true, true);
      }
    });
  }

  public loadOpps(page: number, isInitialLoad: boolean, forceRefresh?: boolean) {
    const search = {
      ProfileId: this.profileId,
      IncludeRevenueItem: true,
      IncludeWorkingWithProfile: true,
      IncludeUser: true,
      PageSize: 10,
      PageNumber: page,
    } as SalesOpportunitySearchDto;

    this._salesOppService.search(search, forceRefresh ?? false).then((data: PagedResultGeneric<SalesOpportunityDto>) => {
      this.salesOpps = data.Result;
    });
  }

  public deleteOpp(id: number) {
    this.rejectText = this._translationService.getInstant('profiles.view.sales-opps.cancel').toUpperCase();
    this.acceptText = this._translationService.getInstant('profiles.view.sales-opps.delete-opp-button').toUpperCase();

    this._confirmationService.confirm({
      key: 'deleteSalesOppCD',
      header: this._translationService.getInstantTitlecase('profiles.view.sales-opps.delete-this-opp'),
      message: this._translationService.getInstantCapitalizeFirstCharacter('profiles.view.sales-opps.delete-opp-body'),
      accept: () => {
        this._salesOppService.delete(id).then(() => {
          this.loadOpps(1, true, true);
        });
      },
      reject: () => {
        this._confirmationService.close();
      },
    });
  }
}
